angular
  .module('app')
  .controller(
    'SitemapController',
    function MyController($scope, ngStudentMenuQuery, appConfigModel, LEANAP_EXPOSE_LEANAP_APIS, ngUserModesService) {
      const menuItems = ngStudentMenuQuery.result.menuItems || [];
      const internalMenuItems = menuItems.filter((_) => _.uri.indexOf('#/') >= 0);
      const externalMenuItems = menuItems.filter((_) => _.uri.indexOf('http') >= 0);

      // Explore: internal menu links from partner student menu
      $scope.sitemap = [
        {
          title: 'Explore',
          links: internalMenuItems.map((_) => {
            return {
              title: _.title,
              uri: _.uri
            };
          })
        }
      ];

      // Planner: shown only when Academic Planner v3 is enabled for the tenant
      if (appConfigModel.isFeatureEnabled(LEANAP_EXPOSE_LEANAP_APIS)) {
        $scope.sitemap.push({
          title: 'Planner',
          links: [
            {
              title: 'Planner',
              uri: ngUserModesService.isAdvisorOnly ? '#/my/ap3/advisor' : '#/my/ap3/student'
            }
          ]
        });
      }

      // External Services: external menu links from partner student menu
      $scope.sitemap.push({
        title: 'External Services',
        links: externalMenuItems.map((_) => {
          return {
            title: _.title,
            uri: _.uri
          };
        })
      });
    }
  );
